import { ControlledForm, ControlledTable } from "Components";
import FilterData from "Components/Filter2/Data";
import { Filter2DataProps } from "DataTypes/Common";
import { FormDataType } from "DataTypes/Form";
import { columnType } from "DataTypes/Table";
import { store } from "Redux/Store";
import { FormatDropdownData } from "Utils/DataFormatter";

export const TableCol: () => columnType[] = () => {
  return [
    ControlledTable.ColumnData.CallerNameCol("15%"),
    ControlledTable.ColumnData.DateTimeCol("15%"),
    ControlledTable.ColumnData.ProgramCol("15%", "text"),
    ControlledTable.ColumnData.CallResultCol("15%"),
    ControlledTable.ColumnData.NextCallCol("20%"),
    ControlledTable.ColumnData.CallNoteCol("20%"),
  ];
};

export const FormDataArr: () => FormDataType[] = () => {
  return [
    {
      id: "patient-lang",
      label: "Language",
      placeholder: "Language",
      boxType: "input-box",
      type: "text",
      boxSize: 1,
      validatetype: "alphanumericPeriod",
      required: false,
      readOnly: true,
    },
    { ...ControlledForm.FormData.CallName(), boxSize: 1 },
    {
      id: "program",
      label: "Program",
      boxType: "input-box",
      type: "text",
      boxSize: 1,
      validatetype: "name",
      required: false,
      readOnly: true,
    },
    {
      ...ControlledForm.FormData.CallResult(),
      dropListHeight: "400px",
    },
    { ...ControlledForm.FormData.NextCall(), boxSize: 2 },
    ControlledForm.FormData.CallNotes(),
  ];
};

export const FilterArr: () => Filter2DataProps[] = () => {
  const { callResultList } = store.getState().list;
  const { eligiblePrgmArr } = store.getState().patient;
  const Arr: Filter2DataProps[] = [
    {
      ...FilterData.prgmName,
      dropArr:
        FormatDropdownData(eligiblePrgmArr, "id", "abbrevation", "abbrevation")
    },
    FilterData.staffMemberName,
    { ...FilterData.callResult, dropArr: callResultList },
  ];
  return Arr;
};
